import { render } from "./CommonSettingsEditor.vue?vue&type=template&id=582bc525&scoped=true"
import script from "./CommonSettingsEditor.vue?vue&type=script&lang=js"
export * from "./CommonSettingsEditor.vue?vue&type=script&lang=js"

import "./CommonSettingsEditor.vue?vue&type=style&index=0&id=582bc525&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582bc525"]])

export default __exports__